import { twoItemLabel } from 'App/data-export/valueTypeRenderers/renderers/_utils/labelHelpers'
import { makeNumberRenderer } from 'App/data-export/valueTypeRenderers/renderers/_utils/makeNumberRenderer'
import type { valueTypeRenderers } from 'App/data-export/valueTypeRenderers/valueTypeRenderers'
import { translate } from 'i18n/i18n'
import { unitConverter } from 'utils/unitConverter/unitConverter'

export const almondBloom: typeof valueTypeRenderers.almondBloom = {
  label: () => translate.phrases.banyanApp('Almond Bloom'),
  block: ({ metadata }) =>
    makeNumberRenderer({
      baseLabel: twoItemLabel([
        twoItemLabel([translate.phrases.banyanApp('Almond Bloom'), metadata.cultivarName]),
        unitConverter.almondBloom().suffix(),
      ]),
      render: (v) => unitConverter.almondBloom(v).valueAsString(),
      metaId: String(metadata.cultivarId),
    }),
}
